"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDisplayAmount = createDisplayAmount;
exports.compareDisplayAmounts = compareDisplayAmounts;
const DEFAULT_DISPLAY_SYMBOL = "$";
const DEFAULT_DISPLAY_VALUE = "0.00";
const DEFAULT_EXPONENT = 2;
const DEFAULT_NEGATIVE = false;
const DEFAULT_DISPLAY_UNIT = "dollars";
function createDisplayAmount({ displaySymbol = DEFAULT_DISPLAY_SYMBOL, displayValue = DEFAULT_DISPLAY_VALUE, exponent = DEFAULT_EXPONENT, negative = DEFAULT_NEGATIVE, displayUnit, valueInMinUnit, }) {
    const sanitizedDisplayValue = displayValue.replace(/,/g, "");
    const calcValueInMinUnit = valueInMinUnit ||
        Math.round(Number(sanitizedDisplayValue) * Math.pow(10, exponent));
    return {
        displaySymbol,
        displayValue,
        exponent,
        negative,
        valueInMinUnit: calcValueInMinUnit,
        displayUnit,
    };
}
/**
 * Reusable utility function to compare two DisplayAmount objects.
 *
 * @param a - The first DisplayAmount object to compare.
 * @param b - The second DisplayAmount object to compare.
 * @returns A number indicating the relative order of the two DisplayAmount objects.
 *          Returns -1 if `a` is less than `b`, 1 if `a` is greater than `b`, and 0 if they are equal.
 *
 * This function compares two DisplayAmount objects primarily based on their `valueInMinUnit` field.
 * The `negative` field is also considered to handle negative amounts.
 * The comparison assumes that `valueInMinUnit` represents the amount in the smallest possible unit,
 * making it the most reliable field for comparison.
 *
 * Example usage:
 * const amount1: DisplayAmount = { displaySymbol: "$", displayValue: "10", exponent: 2, negative: false, valueInMinUnit: 1000 };
 * const amount2: DisplayAmount = { displaySymbol: "$", displayValue: "20", exponent: 2, negative: false, valueInMinUnit: 2000 };
 * const comparisonResult = compareDisplayAmounts(amount1, amount2); // Returns -1
 */
function compareDisplayAmounts(a, b) {
    const { negative: isANegative, valueInMinUnit: aValue } = a;
    const { negative: isBNegative, valueInMinUnit: bValue } = b;
    if (aValue === bValue && isANegative === isBNegative)
        return 0;
    if (isANegative && !isBNegative)
        return -1;
    if (!isANegative && isBNegative)
        return 1;
    const comparison = isANegative ? bValue - aValue : aValue - bValue;
    if (comparison < 0)
        return -1;
    if (comparison > 0)
        return 1;
    return 0;
}
